import { getDaysHoursMinsFromDateNumeric } from './get-days-hours-mins-from-date';

export const getTimeDiff = (
  startDateNumeric: number,
  currentDateNumeric: number
): { daysDiff: number; hoursDiff: number; minutesDiff: number } => {
  const millisecondsDiff = Math.abs(currentDateNumeric - startDateNumeric);

  const dateDiffStats = getDaysHoursMinsFromDateNumeric(millisecondsDiff);

  return { daysDiff: dateDiffStats.days, hoursDiff: dateDiffStats.hours, minutesDiff: dateDiffStats.minutes };
};
